module.exports = __webpack_public_path__ + "static/media/5day@2x.5fb2f608.png";